import { lazy, Suspense } from 'react';
import { useState, useEffect } from 'react';
import { execSeatableSql } from './seatable.js';
import ListCapabilities from './listcapabilities.js';

const componentRegistry = {
  HeroFull: lazy(() => import('./herofull.js')),
  Hero: lazy(() => import('./hero.js')),
  Stats: lazy(() => import('./stats.js')),
  AI: lazy(() => import('./ai.js')),
  Services: lazy(() => import('./services.js')),
  Segments: lazy(() => import('./segments.js')),
  Artifacts: lazy(() => import('./artifacts.js')),
  Clients: lazy(() => import('./clients.js')),
  Quotes: lazy(() => import('./quotes.js')),
  TechStack: lazy(() => import('./techstack.js')),
  Leadership: lazy(() => import('./leadership.js')),
  DomainTopics: lazy(() => import('./domaintopics.js')),
  Footer: lazy(() => import('./footer.js')),
}

function PageSections(props) {
    const [data, setData] = useState(null);
    
    useEffect(() => {
      async function fetchData() {
        const sql = `SELECT PageSection, PageSectionName, imagePosition FROM Sections WHERE \`IsActive\` IS TRUE AND \`Subpages\` = '${props.capability}' ORDER BY Rank`;
        setData(null);
        
        try {
          const rows = await execSeatableSql(sql);
          if (rows && rows.results) {
            setData([...rows.results, {PageSection: [{row_id: 'Footer', display_value: 'Footer'}]}]);
          }
        } catch (err) {
          // setError(err);
        }
      }
      fetchData();
    }, [props.capability]);

    return (
        <>
            {data && data.map((row, index) => {
              const compName = row.PageSection[0].display_value;
              const PageSectionName = row.PageSectionName;
              const imagePosition = row.imagePosition;
              const compRows = componentList(props.capability).filter(e => e.componentName === compName); 
              const compRow = compRows && compRows[0];
              const Component = componentRegistry[compName];

              return (
              <>
                {Component ?
                <Suspense fallback={<div className="text-center"><span class="animated-dots"><span>.</span><span>.</span><span>.</span></span></div>}>
                  <Component {...compRow} PageSectionName={PageSectionName}  imagePosition= {imagePosition}/>
                </Suspense>
                : ''}
              </>
              );
            })} 
        </>
    )
}

function componentList(capabilityDesc) {
    return [
        {componentName: 'HeroFull', capability: capabilityDesc}, 
        {componentName: 'Hero', capability: capabilityDesc}, 
        {componentName: 'Stats', capability: capabilityDesc},
        {componentName: 'AI', capability: capabilityDesc},
        {componentName: 'ListServices'},
        {componentName: 'ListSegments'},
        {componentName: 'Services', capability: capabilityDesc},
        {componentName: 'Segments', capability: capabilityDesc},
        {componentName: 'Artifacts', capability: capabilityDesc},
        {componentName: 'Clients', capability: capabilityDesc},
        {componentName: 'Quotes', capability: capabilityDesc},
        {componentName: 'TechStack', capability: capabilityDesc},
        {componentName: 'Leadership', capability: capabilityDesc},
        {componentName: 'DomainTopics', capability: capabilityDesc},
    ]
}

function ListServices() {
  return (
    <ListCapabilities type="Services" />
  )
}

function ListSegments() {
  return (
    <ListCapabilities type="Segments" />
  )
}

export default PageSections;